import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cloudinaryTransf',
})
export class CloudinaryTransfPipe implements PipeTransform {
  transform(value: any, width: any, height: any): any {
    // const http_to_https = value.replace('http://', 'https://');

    // console.log(http_to_https);

    const cloudinary_string = value.replace(
      '/upload/',
      `/upload/w_${width},h_${height}/`
    );
    return cloudinary_string;
  }
}
